/* Shop the look-paneel (snippets/shop-the-look-sheet.liquid), lookbook en homepage */
(function(){
  if (window.__stlSheet) return;
  window.__stlSheet = true;

  function close(d){ d.classList.remove("is-open"); document.documentElement.classList.remove("lock-all"); }
  function closeAll(){ document.querySelectorAll(".stl-sheet.is-open").forEach(close); }

  /* balk onderin: "Select size" tot er een maat gekozen is, dan "Add to cart" */
  function setCta(sheet, variantId){
    var cta = sheet.querySelector(".stl-sheet__cta");
    cta.dataset.var = variantId || "";
    cta.disabled = !variantId;
    cta.querySelector(".stl-sheet__cta-label").textContent = variantId ? cta.dataset.labelAdd : cta.dataset.labelSelect;
  }

  document.addEventListener("click", function(e){
    var o = e.target.closest("[data-stl-open]");
    if (o){
      var d = document.getElementById(o.getAttribute("data-stl-open"));
      if (!d) return;
      /* naar de body: een ouder met transform (slider, animatie) maakt van position:fixed anders absolute.
         Na het verplaatsen eerst de beginstand laten tekenen (reflow), anders speelt de
         schuif-animatie de eerste keer niet. */
      if (d.parentElement !== document.body){
        document.body.appendChild(d);
        var panel = d.querySelector(".stl-sheet__panel");
        if (panel) getComputedStyle(panel).transform; /* beginstand vastleggen */
      }
      d.classList.add("is-open");
      document.documentElement.classList.add("lock-all"); /* zelfde scroll-lock als de thema-drawers */
      return;
    }
    var sheet = e.target.closest(".stl-sheet");
    if (!sheet) return;

    if (e.target.closest("[data-stl-close]")){ close(sheet); return; }

    /* flatlay bovenin: ander item tonen */
    var thumb = e.target.closest(".stl-sheet__thumb");
    if (thumb){
      var i = thumb.dataset.pick;
      sheet.querySelectorAll(".stl-sheet__thumb").forEach(function(t){ t.classList.toggle("is-active", t === thumb); });
      sheet.querySelectorAll(".stl-sheet__pick").forEach(function(p){ p.hidden = p.dataset.pick !== i; });
      sheet.querySelectorAll(".stl-sheet__size.is-selected").forEach(function(s){ s.classList.remove("is-selected"); });
      setCta(sheet, null);
      return;
    }

    var size = e.target.closest(".stl-sheet__size");
    if (size && !size.disabled){
      sheet.querySelectorAll(".stl-sheet__size.is-selected").forEach(function(s){ s.classList.remove("is-selected"); });
      size.classList.add("is-selected");
      setCta(sheet, size.dataset.var);
      return;
    }

    var cta = e.target.closest(".stl-sheet__cta");
    if (cta && cta.dataset.var && !cta.classList.contains("is-adding")){
      cta.classList.add("is-adding");
      cta.querySelector(".stl-sheet__cta-label").textContent = cta.dataset.labelAdding;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: cta.dataset.var, quantity: 1 })
      }).then(function(r){
        if (!r.ok) throw new Error("add failed");
        close(sheet);
        /* zelfde als de maat-sheet (custom.js): winkelwagen verversen en openen */
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        setTimeout(function(){ var c = document.querySelector("cart-drawer"); if (c) c.setAttribute("open", "open"); }, 400);
      }).catch(function(){}).finally(function(){
        cta.classList.remove("is-adding");
        sheet.querySelectorAll(".stl-sheet__size.is-selected").forEach(function(s){ s.classList.remove("is-selected"); });
        setCta(sheet, null);
      });
    }
  });

  document.addEventListener("keydown", function(e){ if (e.key === "Escape") closeAll(); });
})();
